export default __webpack_public_path__ + "4f78aa3423045f74600e811ae9901121.jpg";